import React, { useEffect, useState } from 'react';
import BoardButton from '../BoardButton';
import '../../components/modals/styles/HowToPlay.css';

const LS_KEY = 'combos_show_timer';

const HowToPlay = ({ onStart, onClose }) => {

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                if (onClose) onClose();
            }
        }
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [onClose]);

    const [showTimer, setShowTimer] = useState(true);

    // initialize from localStorage
    useEffect(() => {
        try {
            const raw = localStorage.getItem(LS_KEY);
            if (raw !== null) setShowTimer(raw === 'true');
        } catch (e) { /* ignore */ }
    }, []);

    const dispatchShowTimerEvent = (val) => {
        try {
            const ev = new CustomEvent('combos:showTimerChanged', { detail: { showTimer: val } });
            window.dispatchEvent(ev);
        } catch (e) { /* ignore */ }
    };

    const persistShowTimer = (val) => {
        try { localStorage.setItem(LS_KEY, String(val)); } catch (e) { /* ignore */ }
        dispatchShowTimerEvent(val);
    };

    const handleToggleShowTimer = () => {
        setShowTimer((s) => {
            const next = !s;
            persistShowTimer(next);
            return next;
        });
    };

    const handleStart = () => {
        persistShowTimer(showTimer);
        if (onStart) onStart();
    };

    // clicking outside should not close this modal; keep only Escape-to-close

    return (
        <div className='howto-modal' role='dialog' aria-modal='true' tabIndex='-1'>
            <div className='howto-modal-content'>
                <h2 className='howto-modal-title'>How to play</h2>
                <p>Start with the first target number. Use the operator buttons to transform the current number to match each target in sequence.</p>
                <p>Reach each target in order. When all targets are reached the round ends.</p>

                <div style={{ marginTop: '0.25rem', textAlign: 'center' }}>
                    <span style={{ fontSize: '1.8vh', lineHeight: 1 }}>
                        The timer starts when you press <strong>Start</strong>.
                    </span>
                </div>

                <div style={{ marginTop: '1rem' }}>
                    <BoardButton className='start-button' onClick={handleStart} label={'Start'}>Start</BoardButton>
                </div>

                <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '2vh' }}>
                        <input
                            type='checkbox'
                            checked={showTimer}
                            onChange={handleToggleShowTimer}
                        />
                        Show timer
                    </label>
                </div>
            </div>
        </div>
    );
};

export default HowToPlay;
